<article [ngClass]="[needsSaving() ? 'not-saved' : 'saved', saving ? 'saving' : '']">
  <div class="content grid-2">
    <div>
      <app-weight-table (needsSavingEmitter)="updateWeightsNeedSaving($event)"></app-weight-table>
      <app-report-field-options (needsSavingEmitter)="updateReportFieldsNeedSaving($event)"></app-report-field-options>
    </div>
    <app-duplikit-options (needsSavingEmitter)="updateOptionsNeedSaving($event)">
    </app-duplikit-options>
  </div>
  <section class="footer-btns"
           *ngIf="displayFooterButtons()"
           [ngClass]="[needsSaving() ? 'not-saved' : 'saved', saving ? 'saving' : '']">
    <button theme="nav" (click)="saveSettings()" appRipple *ngIf="needsSaving()">
      <i class="bhi-save icon-left"></i>
      <span>Sav</span><span class="not-saved-text">e</span><span class="saving-text">ing</span><span class="saved-text">ed</span>
    </button>
  </section>
</article>
